export default 
{
  methods: {
    checkPermission(user_obj, permission_module, permission_sub_module, permission_sys_function, ex_con){
      // console.log(user_obj);
      // console.log(permission_module+" - "+permission_sub_module+" - "+permission_sys_function+" - "+ex_con);

      // no sys permissions, old way
      if(!user_obj['sys_permissions']){
        if(typeof ex_con == 'undefined'){
          return false;
        }else{
          return ex_con;
        }
      }else{
        let is_ok = false;
        if(permission_module){
          if(user_obj['sys_permissions'][permission_module]){
            is_ok = true;
          }else{
            is_ok = false;
          }
        }

        if(permission_sub_module){
          if(user_obj['sys_permissions'][permission_module][permission_sub_module]){
            is_ok = true;
          }else{
            is_ok = false;
          }
        }

        if(permission_sys_function){
          if(user_obj['sys_permissions'][permission_module] && user_obj['sys_permissions'][permission_module][permission_sub_module] && user_obj['sys_permissions'][permission_module][permission_sub_module][permission_sys_function]){
            is_ok = true;
          }else{
            is_ok = false;
          }
        }

        // console.log(permission_module+" - "+permission_sub_module+" - "+permission_sys_function+" >> "+is_ok);

        return is_ok;
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/mixins/global_function.js